import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CountrySelector } from "./CountrySelector";
import { PayPeriodSelector } from "./PayPeriodSelector";
import { SalaryInput } from "./SalaryInput";
import { StateSelector } from "./StateSelector";
import { type CountryCode, type PayPeriod } from "@shared/schema";
import { Label } from "@/components/ui/label";

interface InputPanelProps {
  salary: number;
  setSalary: (value: number) => void;
  countryCode: CountryCode;
  setCountryCode: (value: CountryCode) => void;
  payPeriod: PayPeriod;
  setPayPeriod: (value: PayPeriod) => void;
  stateCode: string;
  setStateCode: (value: string) => void;
}

export function InputPanel({
  salary,
  setSalary,
  countryCode,
  setCountryCode,
  payPeriod,
  setPayPeriod,
  stateCode,
  setStateCode
}: InputPanelProps) {
  const showStateSelector = countryCode === "us";

  return (
    <Card className="h-fit lg:sticky lg:top-20 z-40 overflow-hidden">
      <CardHeader>
        <CardTitle className="text-lg">Calculate Your Salary</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6 overflow-hidden">
        <div className="space-y-2">
          <Label className="text-sm font-medium">Country</Label>
          <CountrySelector
            value={countryCode}
            onChange={setCountryCode}
          />
        </div>

        {showStateSelector && (
          <StateSelector
            value={stateCode}
            onChange={setStateCode}
          />
        )}

        <SalaryInput
          value={salary}
          onChange={setSalary}
          countryCode={countryCode}
        />

        <div className="space-y-2">
          <Label className="text-sm font-medium">Pay Period</Label>
          <PayPeriodSelector
            value={payPeriod}
            onChange={setPayPeriod}
          />
        </div>

        <p className="text-xs text-muted-foreground pt-2 border-t border-border">
          Tax rates updated for 2026 (UK/AU/NZ: 2026/2027). Calculations are estimates only.
        </p>
      </CardContent>
    </Card>
  );
}
